<template>
    <div class="p-grid" style="width: 350px">
        <span class="p-col-12 p-text-bold">Opdatering af EAK koden</span>
        <div class="p-col-12 p-text-center">
            <select size="1" id="part1" name="part1" v-model="selectedPart1" @change="fetchUnderlyingEakCodes">
                <option v-for="code in part1codes" :key="code" :value="code" :selected="code === selectedPart1">
                    {{ code }}
                </option>
            </select>
            :
            <select size="1" id="part2" name="part2" v-model="selectedPart2" @change="fetchUnderlyingEakCodes">
                <option v-for="code in part2codes" :key="code" :value="code" :selected="code === selectedPart2">
                    {{ code }}
                </option>
            </select>
            :
            <select size="1" id="part3" name="part3" v-model="selectedPart3" @change="fetchUnderlyingEakCodes">
                <option v-for="code in part3codes" :key="code" :value="code" :selected="code === selectedPart3">
                    {{ code }}
                </option>
            </select>
        </div>
        <div class="p-col-12">
            <hr noshade size="1" color="#C0C0C0">
        </div>
        <div class="p-col-12">
            <div v-if="unauthorized" style="color: red; text-align: center; font-weight: bold;">
                You are not authorized.
            </div>
            <div v-else-if="error" style="color: red; text-align: center; font-weight: bold;">
                {{ $t('somethingWentWrong') }}
            </div>
            <ul v-else>
                <span class="p-text-bold">EAK-kode beskrivelse:</span>
                <li v-for="eakCode in eakCodes" :key="eakCode.value" v-html="eakCode.description"></li>
            </ul>
        </div>
        <div class="p-col-12" style="display: flex; justify-content: space-evenly;">
            <input type="submit" value="Annuller" id="close" class="button" onclick="window.close()"/>
            <input v-if="unauthorized" type="submit" value="Gå til login" id="test" class="button" @click="redirectToLogin"/>
            <input v-else type="submit" value="Gem" id="btnFinish" class="button" @click="updateDisposalEak">
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {
    props: {
        url: String
    },
    data() {
        return {
            id: null,
            part1codes: [],
            part2codes: [],
            part3codes: [],
            selectedPart1: null,
            selectedPart2: null,
            selectedPart3: null,
            eakCodes: null,
            error: false,
            unauthorized: false,
            isNewEak: false
        };
    },
    created() {
        this.id = this.$route.params.id;

        this.part1codes = this.part1codes.concat(Array.from({ length: 21 }, (v, i) => ("" + i).padStart(2, "0")));
        this.part2codes = this.part2codes.concat(Array.from({ length: 14 }, (v, i) => ("" + i).padStart(2, "0")));
        this.part3codes = this.part3codes.concat(Array.from({ length: 100 }, (v, i) => ("" + i).padStart(2, "0")));
    },
    mounted() {
        if (isNaN(this.id)) {
            this.isNewEak = true;
            return;
        }

        axios.get(this.url.replace(':id', this.id))
            .then(response => response.data)
            .catch(errorResponse => {
                if (errorResponse.response.status === 403) {
                    this.unauthorized = true;
                } else {
                    this.error = true;
                }
            })
            .then(disposal => {
                const eak = disposal.eak || "000000";

                this.selectedPart1 = eak.substring(0, 2);
                this.selectedPart2 = eak.substring(2, 4);
                this.selectedPart3 = eak.substring(4, 6);
            })
            .then(() => this.fetchUnderlyingEakCodes());
    },
    methods: {
        fetchUnderlyingEakCodes() {
            const url = `/api/v4/installations/disposals/eak/${this.selectedPart1}/${this.selectedPart2}/${this.selectedPart3}`;

            axios.get(url)
                .then(response => response.data)
                .catch(errorResponse => {
                    if (errorResponse.response.status === 403) {
                        this.unauthorized = true;
                    } else {
                        this.error = true;
                    }
                })
                .then(response => this.eakCodes = response);
        },
        updateDisposalEak() {
            if (this.isNewEak) {
                this.postEakChoiceToOpener();
            }

            const url = this.url.replace(':id', this.id);

            axios.put(url, { eak: this.selectedPart1 + this.selectedPart2 + this.selectedPart3 })
                .then(() => {
                    this.postEakChoiceToOpener();
                })
                .catch(errorResponse => {
                    if (errorResponse.response.status === 403) {
                        this.unauthorized = true;
                    } else {
                        this.error = true;
                    }
                });
        },
        redirectToLogin() {
            this.$router.push({ name: 'Home', query: { continue: window.location.href } });
        },
        postEakChoiceToOpener() {
            window.opener.postMessage({ eak: this.selectedPart1 + this.selectedPart2 + this.selectedPart3 }, '*');
            window.close();
        }
    }
}
</script>